import environment, { Environment } from './base';

/*
 * base.ts is the default environment for production.
 * You shouldn't have override anything.
 */

const baseApi = process.env.REACT_APP_B3_FRONT_URL || 'http://localhost:8080';
const baseApiV2 = process.env.REACT_APP_B3_SERVICES_V2 || 'http://localhost:3000';

const env = environment(baseApi, baseApiV2);

const productionEnv: Environment = {
    ...env,
    // override anything that gets added from base.
};

export default productionEnv;
